import { render, staticRenderFns } from "./ChupinShenhe.vue?vue&type=template&id=7413afdb&scoped=true"
import script from "./ChupinShenhe.vue?vue&type=script&lang=js"
export * from "./ChupinShenhe.vue?vue&type=script&lang=js"
import style0 from "./ChupinShenhe.vue?vue&type=style&index=0&id=7413afdb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7413afdb",
  null
  
)

export default component.exports